<div class="filter-pills-row" *ngIf="genomeDisplayName" [title]="'Genome: ' + genomeDisplayName">
  <span class="filter-pill">Genome: {{ genomeDisplayName }}</span>
</div>
<div class="filter-pills-row" *ngIf="filterPills.length > 0" [title]="filterPillsTitle">
  <span class="filter-pill" *ngFor="let pill of filterPills">{{ pill }}</span>
</div>
